define('uikit/modules/tag.input',['require','exports','module','underscore','../elements/input','../collections/search.results','../extra/input.change.tracker','../extra/key.codes','../channel','templates'],function(require, exports, module){
  var _ = require('underscore');
  var Input = require('../elements/input');
  var SearchResults = require('../collections/search.results');
  var InputChangeTracker = require('../extra/input.change.tracker');
  var CODES = require('../extra/key.codes');
  var channel = require('../channel');
  var Templates = require('templates');

  function setCaretPosition(elem, caretPos) {
    if (elem != null) {
      if (elem.createTextRange) {
        var range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      } else {
        if (elem.selectionStart) {
          elem.focus();
          elem.setSelectionRange(caretPos, caretPos);
        } else {
          elem.focus();
        }
      }
    }
  }

  var TagInput = Input.extend({

    className: Input.prototype.className + ' visual search',

    options: _.extend({}, Input.prototype.options, {
      searchStartCharCode: 64
    }),

    forceUpdate: _.extend({}, Input.prototype.forceUpdate, {
      searchStartCharCode: true
    }),

    events: _.extend({}, Input.prototype.events, {
      'keyup @ui.input': 'onInputKeyUp',
      'keydown @ui.input': 'onInputKeyDown'
    }),

    initialize: function() {
      Input.prototype.initialize.apply(this, arguments);
      this.resultsView = new SearchResults();
    },

    template: function() {
      return Input.prototype.template.apply(this, arguments) + '<ui name="resultsView"/>';
    },

    onResultsViewResultSelected: function(results, selected) {
      this.insertSelectedText();
      this.stopSearch();
    },

    onResultsViewResultActive: function() {
      // don't do anything here yet
    },

    onBlur: function() {
      // we always want to stop the search when we blur
      this.stopSearch();
    },

    onInputKeyDown: function(ev) {
      var tokens              = this.children,
          keyCode             = ev.keyCode,
          preInputTextContent = this.getSearchText();

      // Cache initial text value
      this._oldTextContent = preInputTextContent;

      if (keyCode === CODES.ENTER_KEY) {
        ev.preventDefault();

      // If tab key and there is text content, then prevent default behavior
      } else if (keyCode === CODES.TAB_KEY && preInputTextContent) {
        ev.preventDefault();

      } else if (keyCode === CODES.TAB_KEY) {

      // If backspace key and there is text content, focus and select the last token
    } else if (keyCode === CODES.BACKSPACE_KEY && this._isSearching) {
        if (preInputTextContent.length === 0) {
          // Remove focus on input
          this.stopSearch();
          // ev.preventDefault();
        }
      // If down arrow key, select next sibling of the active result
      } else if (keyCode === CODES.DOWNARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();
        this.resultsView.selectNextResult();

      // If up arrow key, select previous sibling of active result
      } else if (keyCode === CODES.UPARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();
        this.resultsView.selectPreviousResult();

      // If keyCode is one of the token separators, then prevent default behavior
      } else if (keyCode === CODES.ESCAPE_KEY) {
        ev.preventDefault();
        this.stopSearch();
      }
    },

    onInputKeyUp: function(ev) {
      var keyCode     = ev.keyCode,
          textContent = this.getSearchText();

      // Prevent default behaviour of arrow keys, if search results are displayed
      if (keyCode === CODES.DOWNARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();

      } else if (keyCode === CODES.UPARROW_KEY && !this.isResultsEmpty()) {
        ev.preventDefault();

      // Generate a new token, if pressing enter
      } else if (keyCode === CODES.ENTER_KEY || keyCode === CODES.TAB_KEY) {
        ev.preventDefault();

        // Only if text entered, or a search result is selected
        if ((!this.isResultsEmpty() && this.resultsView.getSelected()))  {
          this.insertSelectedText();
        }
        this.stopSearch();
      } else if (this._isSearching) {
        this.triggerSearchText();
      } else if (keyCode === this.searchStartCharCode) {
        this.startSearch();
        this.triggerSearchText();
      }
    },

    insertSelectedText: function() {
      var selected    = this.resultsView.getSelected(),
          currentText = this.getSearchText(),
          value       = this.value == null ? '' : String(this.value),
          text        = '';

      if (!this.inputTracker) { return; }

      if (selected && _.isFunction(this.getOption('textFormatter'))) {
        text = this.getOption('textFormatter').call(this, selected.model);
      } else if (selected) {
        text = selected.text;
      }

      this.value = this.inputTracker.leftValue(1)
          + text
          + this.inputTracker.rightValue()

      setCaretPosition(this.ui.input.get(0), this.inputTracker.startIndex + text.length-1);
    },

    startSearch: function() {
      this._isSearching = true;
      this.inputTracker = new InputChangeTracker(this.ui.input);
    },

    stopSearch: function() {
      this._isSearching = false;
      this.inputTracker = null;
      this.resetSearchView();
    },

    resetSearchView: function() {
      this.hideResultsView();
    },

    getSearchText: function() {
      return this.inputTracker ? this.inputTracker.value() : '';
    },

    triggerSearchText: function() {
      this.triggerMethod('search:results:text', this.getSearchText());
    },

    hideResultsView: function() {
      this.resultsView.collection = null;
    },

    isResultsEmpty: function() {
      return !(this.resultsView.collection && this.resultsView.collection.length);
    }

  });

  // register the tag input component
  channel.reply('tag-input', function() {
    return TagInput;
  });

  module.exports = TagInput;
});
